<script>
import Notification from "@/components/reUse/Notification.vue";

export default {
  name: "NastavitveUpravitelj",
  components: {Notification},
  data() {
    return {
      ime: '',
      priimek: '',
      posodabljam: false,
      text: '',
      types: '',
      ShowNoti: false,
    }
  },
  mounted() {
    this.BeriUpravitelja();
  },
  methods: {
    BeriUpravitelja() {
      this.posodabljam = true;
      axios.get('api/nastavitve/upravitelj/uredi/').then(response => {
        this.ime = response.data.ime;
        this.priimek = response.data.priimek;
        this.posodabljam = false;
      }).catch(napaka => {
        this.text = 'Prišlo je do napake';
        if(napaka.response.napaka) {
          this.text = napaka.response.napaka;
        }
        this.types = 'Napaka';
        this.ShowNoti = true;
        this.posodabljam = false;
      })
    },
    PosodobiZapis() {
      this.posodabljam = true;
      let podatki = new URLSearchParams();
      podatki.append('ime', this.ime);
      podatki.append('priimek', this.priimek);
      axios.post('./api/nastavitve/upravitelj/uredi/', podatki, {withCredentials: true}).then((response) => {
        this.posodabljam = false;
        this.text = response.data.sporocilo;
        this.types = 'Uspešno';
        this.ShowNoti = true;
      }).catch((napaka) =>{
        this.posodabljam = false;
        this.text = 'Prišlo je do napake';
        if(napaka.response.napaka) {
          this.text = napaka.response.napaka;
        }
        this.types = 'Napaka';
        this.ShowNoti = true;
      });
    }
  }
}
</script>

<template>
  <div class="pregled-povrsin-container">
    <main class="main-content text-center" >
      <form class="form-card" @submit.prevent="PosodobiZapis">
        <h2>Podatki upravitelja</h2>
        <p>Vnesite ime in priimek upravitelja</p>
        <p>Ime in priimek sta uporabljena pri dnevnem razporedu za vršilca pregleda.</p>

        <div class="modern-form-group">
          <label class="user-modern-form-label text-start">
            Ime
          </label>

          <div class="modern-input-group">
            <i class="fas fa-user"></i>

            <input
                class="users-modern-form-input"
                autocomplete="off"
                type="text"
                v-model="ime"
                placeholder="Ime"
                required
            />
          </div>
        </div>

        <div class="modern-form-group">
          <label class="user-modern-form-label text-start">
            Priimek
          </label>

          <div class="modern-input-group">
            <i class="fas fa-user"></i>

            <input
                class="users-modern-form-input"
                autocomplete="off"
                type="text"
                v-model="priimek"
                placeholder="Priimek"
                required
            />
          </div>
        </div>

        <button type="submit" class="submit-btn" :disabled="posodabljam">
          Posodobi
          <i class="fas fa-spinner fa-spin" v-if="posodabljam"></i>
        </button>
      </form>
    </main>
  </div>
  <!-- OBVESTILA -->
  <Transition name="fade">
    <Notification v-if="ShowNoti" :message="this.text" :type="this.types" @closeNotification="ShowNoti = false" />
  </Transition>
</template>
 <style>
    .form-card {
      color: #fff;
      width: 100%;
      max-width: 100%;
      padding: 32px;
      background: #2f3a45;
      border: 1px solid #314868;
      border-radius: 18px;
      box-shadow: 0 15px 40px rgba(0, 0, 0, 0.35);
    }

    .form-card h2 {
      margin: 0 0 8px;
      font-size: 25px;
      text-align: center;
    }

    .form-card p {
      margin: 0 0 28px;
      color: #b8c4d0;
      text-align: center;
      font-size: 14px;
    }

    .submit-btn {
      width: 100%;
      height: 52px;
      margin-top: 8px;
      border: 1px solid #314868;
      border-radius: 11px;
      background: #314868;
      color: #fff;
      font-size: 15px;
      font-weight: 600;
      cursor: pointer;
      transition: all 0.2s ease;
    }

    .submit-btn:hover {
      background: #3b587c;
      border-color: #93c5fd;
      transform: translateY(-1px);
    }

    .submit-btn:active {
      transform: translateY(0);
    }
  </style>